import * as React from 'react';
// store/Providers.js
import { Provider } from "react-redux";
import store from "./store"; // No need to import persistor anymore

const Providers = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};

export default Providers;
